import React from 'react';
import ConfusionMatrixComparison from './confusionMatrix/ConfusionMatrixComparison';
import { CardDefault } from '@spark';
import './confusionMatrix/ConfusionMatrixComparison.css';

export default function LabelConfusionMatrix({
  payload,
  showComparison,
  oldModelTitle,
  newModelTitle,
  selectedLabel,
}) {
  if (!payload) return null;
  return (
    <CardDefault
      type="collapsed"
      open={false}
      title="Confusion Matrix Comparison"
      subtitle="Analyze where the model succeeded and where it made mistakes by comparing predicted vs. actual outcomes"
      showSubtitle={true}
      border="yes"
      fullWidth
      className="fs-unmask cm-confusion-card"
    >
      <div className="cm-card-body">
        <ConfusionMatrixComparison
          payload={payload}
          showComparison={showComparison}
          oldModelTitle={oldModelTitle}
          newModelTitle={newModelTitle}
          selectedLabel={selectedLabel}
        />
      </div>
    </CardDefault>
  );
}

